import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import {
	OfferService,
	ClassificationService,
	PricelistService
} from '../../services/index';
import { Offer, SelectItem } from '../../models/index';
import * as globals from '../../../shared/globals';

import { LazyLoadEvent, Message, MenuItem } from 'primeng/primeng';

@Component({
  selector: 'app-offer-table',
  templateUrl: './offer-table.component.html',
  styleUrls: ['./offer-table.component.scss'],
  animations: []
})
export class OfferTableComponent implements OnInit {
	@Input('company') companyId: number;
	@Input('contact') contactId: number;
	@Input('offerCompleted') offerCompleted: boolean;

	offers: Array<Offer> = [];
	totalOffers: number = 0;

	showLoadingError: boolean = false;
	loadingOffers: boolean = false;

	globals = globals;

	lastEvent: LazyLoadEvent;

	selectedOffer: Offer;
	cmItems: MenuItem[];

	constructor(
		private router: Router,
		private translate: TranslateService,
		private offerService: OfferService,
		private classService: ClassificationService,
		private pricelistService: PricelistService
	) {}

	ngOnInit()
	{
		this.translate.get(['View', 'Delete']).subscribe(res => {
	        this.cmItems = [
	            {label: res['View'], icon: 'fa-search', command: (event) => this.router.navigate(['/offer', this.selectedOffer.id])},
	            {label: res['Delete'], icon: 'fa-close', command: (event) => this.deleteOffer(this.selectedOffer)}
			];
		});

		//this.loadOffers();

		/*this.offerService.get().subscribe(data => {
			this.offers = data.data;
			this.totalOffers = data.total;

			this.showLoadingError = false;
			this.loadingOffers = false;
		}, err => {
			this.showLoadingError = true;
			this.loadingOffers = false;
		});*/
	}

	loadOffers(event?: LazyLoadEvent)
	{
		if(!event) {
			event = this.lastEvent;
		}

		if(!event) {
			this.showLoadingError = true;
			return;
		}

		this.lastEvent = event;

		if(this.contactId) {
			event.filters.contact_id = {
				matchMode: 'equal',
				value: this.contactId
			};
		} else if(this.companyId) {
			event.filters.company_id = {
				matchMode: 'equal',
				value: this.companyId
			};
		} else if(typeof this.offerCompleted !== 'undefined') {
			event.filters.offer_completed = {
				matchMode: 'equal',
				value: this.offerCompleted
			};
		}

		this.offerService.getLazy(event).subscribe(data => {
			this.offers = data.data;
			this.totalOffers = data.total;

			this.showLoadingError = false;
			this.loadingOffers = false;
		}, err => {
			this.showLoadingError = true;
			this.loadingOffers = false;
		});
	}

	deleteOffer(offer: Offer): void {
		this.offerService.delete(offer.id).subscribe(response => {
			this.loadOffers();
		});
	}

	onRowDblclick(event) {
		this.router.navigate(['/offer', event.data.id])
	}

	/*loadOffers(event: LazyLoadEvent) {
		if(this.loadingOffers) {
			return;
		}
		this.loadingOffers = true;

		this.offerService.get().subscribe(data => {
			this.offers = data.data;
			this.showLoadingError = false;
			this.loadingOffers = false;
		}, err => {
			this.showLoadingError = true;
			this.loadingOffers = false;
		});
	}*/

	isUndefined(val) { return typeof val === 'undefined'; }

}



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/modules/offer-table/offer-table.component.ts